"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Telemetry = void 0;
var Authority_1 = __importDefault(require("../lib/Authority"));
var AbstractAuthorityServer_1 = require("./AbstractAuthorityServer");
var debug_1 = __importDefault(require("debug"));
var Telemetry_1 = require("../lib/Telemetry");
Object.defineProperty(exports, "Telemetry", { enumerable: true, get: function () { return Telemetry_1.Telemetry; } });
var debug = debug_1.default('jwt-cert-sdk:AbstractauthorityClient');
/**
 * Class meant to be extended to match any authority server implementation out
 * there, that will take care of:
 * - all comunication to the server
 * - authentication
 */
var AbstractAuthorityClient = /** @class */ (function (_super) {
    __extends(AbstractAuthorityClient, _super);
    function AbstractAuthorityClient(issuer) {
        var _this = _super.call(this, issuer) || this;
        _this._revoked_list = {};
        _this._revoke_meta = {
            last_checked_at: null,
            last_generated_at: null,
            last_updated_at: null,
        };
        _this._revokedListRefreshing = null;
        return _this;
    }
    AbstractAuthorityClient.prototype.refreshRevokedList = function (ttl_in_seconds, telemetry) {
        if (ttl_in_seconds === void 0) { ttl_in_seconds = 3600; }
        return __awaiter(this, void 0, void 0, function () {
            var meta;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!telemetry) {
                            telemetry = new Telemetry_1.Telemetry('AuthorityClient refreshRevokedList');
                        }
                        return [4 /*yield*/, this.dbGetRevokeListCheckMeta()];
                    case 1:
                        meta = _a.sent();
                        if (!(ttl_in_seconds <= 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._debounceGetRevokeList(telemetry, meta)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        if (!(meta.last_checked_at === null || meta.last_checked_at < AbstractAuthorityServer_1.TimestampNow() - ttl_in_seconds)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this._debounceGetRevokeList(telemetry, meta)];
                    case 4: return [2 /*return*/, _a.sent()];
                    case 5:
                        debug('revoked list still valid, ttl %d', ttl_in_seconds);
                        return [2 /*return*/, false];
                }
            });
        });
    };
    AbstractAuthorityClient.prototype._debounceGetRevokeList = function (telemetry, meta) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this._revokedListRefreshing === null)) return [3 /*break*/, 1];
                        debug('refreshing revoked list');
                        // store our download attempt here
                        this._revokedListRefreshing = telemetry
                            .seq('fetching list', function (t) {
                            // always shave 1 seconds from the last update time, in case
                            // something else came in since
                            // TODO this might not be necessary if we use more precise timestamp
                            return _this.getRevokedCertificates(meta.last_updated_at ? meta.last_updated_at - 1 : undefined, t);
                        })
                            .then(function (revokedList) {
                            var _a, _b;
                            var updateLastCheckPromise = _this.dbSetRevokeListCheckMeta({
                                last_checked_at: AbstractAuthorityServer_1.TimestampNow(),
                                last_generated_at: (_a = revokedList === null || revokedList === void 0 ? void 0 : revokedList.generated_at) !== null && _a !== void 0 ? _a : meta.last_generated_at,
                                last_updated_at: (_b = revokedList === null || revokedList === void 0 ? void 0 : revokedList.updated_at) !== null && _b !== void 0 ? _b : meta.last_updated_at,
                            });
                            if (revokedList === null) {
                                debug('refreshing revoked list - no change');
                                // no change
                            }
                            else {
                                debug('refreshing revoked list - updating list');
                                return telemetry
                                    .seq('updating revoke list', function (t) { return _this.dbUpdateRevokedList(revokedList, t); })
                                    .then(function () { return updateLastCheckPromise; });
                            }
                            return updateLastCheckPromise;
                        })
                            .then(function () {
                            _this._revokedListRefreshing = null;
                        });
                        return [2 /*return*/, true];
                    case 1: return [4 /*yield*/, this._revokedListRefreshing];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, false];
                }
            });
        });
    };
    AbstractAuthorityClient.prototype.isCertificateRevoked = function (certificate_id, ttl_in_seconds, telemetry) {
        if (ttl_in_seconds === void 0) { ttl_in_seconds = 3600; }
        return __awaiter(this, void 0, void 0, function () {
            var status;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!telemetry) {
                            telemetry = new Telemetry_1.Telemetry('AuthorityClient isCertificateRevoked');
                        }
                        return [4 /*yield*/, telemetry.seq('refreshRevokeList', function (t) { return _this.refreshRevokedList(ttl_in_seconds, t); })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, telemetry.seq('dbIsCertificateInRevokedList', function (t) {
                                return _this.dbIsCertificateInRevokedList(certificate_id, t);
                            })];
                    case 2:
                        status = _a.sent();
                        debug('Cert %s revoked? %j', certificate_id, status);
                        return [2 /*return*/, status];
                }
            });
        });
    };
    AbstractAuthorityClient.prototype.areAnyCertificateRevoked = function (certificate_ids, ttl_in_seconds, telemetry) {
        if (ttl_in_seconds === void 0) { ttl_in_seconds = 3600; }
        return __awaiter(this, void 0, void 0, function () {
            var checkTelemetry, revoked_list;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!telemetry) {
                            telemetry = new Telemetry_1.Telemetry('Authorities areAnyCertificateRevoked');
                        }
                        return [4 /*yield*/, telemetry.seq('refreshRevokeList', function (t) { return _this.refreshRevokedList(ttl_in_seconds, t); })];
                    case 1:
                        _a.sent();
                        checkTelemetry = telemetry.stamp('check certs');
                        return [4 /*yield*/, Promise.all(certificate_ids.map(function (cert_id) {
                                return checkTelemetry.fork('checking cert ' + cert_id, function (t) {
                                    return _this.dbIsCertificateInRevokedList(cert_id, t).then(function (status) { return (status ? cert_id : null); });
                                });
                            }))];
                    case 2:
                        revoked_list = ((_a.sent()).filter(function (cert_id) { return cert_id !== null; }));
                        debug('Any cert revoked from %O? Result:%O', certificate_ids, revoked_list);
                        return [2 /*return*/, revoked_list];
                }
            });
        });
    };
    /**
     * the following 4 methods (dbGetLastCheckedAt, dbSetLastCheckedAt,
     * dbUpdateRevokedList and dbIsCertificateInRevokedList) can be overriden if
     * persistent storage should be used between checks, w/o having to
     * re-download the full list.
     *
     * A certificate is expected to be kept in the revoked list until it's
     * expiration date, according to the clock that will be validating it.
     */
    AbstractAuthorityClient.prototype.dbGetRevokeListCheckMeta = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._revoke_meta];
            });
        });
    };
    AbstractAuthorityClient.prototype.dbSetRevokeListCheckMeta = function (meta) {
        return __awaiter(this, void 0, void 0, function () {
            var k;
            return __generator(this, function (_a) {
                for (k in meta) {
                    this._revoke_meta[k] = meta[k];
                }
                return [2 /*return*/];
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    AbstractAuthorityClient.prototype.dbUpdateRevokedList = function (revokedList, telemetry) {
        return __awaiter(this, void 0, void 0, function () {
            var i, cert;
            return __generator(this, function (_a) {
                // merge the lists
                for (i = 0; i < revokedList.certificates.length; i++) {
                    cert = revokedList.certificates[i];
                    this._revoked_list[cert.certificate_id] = cert;
                }
                return [2 /*return*/];
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    AbstractAuthorityClient.prototype.dbIsCertificateInRevokedList = function (certificate_id, telemetry) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (certificate_id in this._revoked_list) {
                    return [2 /*return*/, true];
                }
                return [2 /*return*/, false];
            });
        });
    };
    return AbstractAuthorityClient;
}(Authority_1.default));
exports.default = AbstractAuthorityClient;
